'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var hqoTheme = require('./hqo-theme-79db6cc8.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
require('styled-components');
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
var formField = require('./form-field-8601b6d9.js');
require('./enums-de2d9d36.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
var useOnClickOutside_hook = require('./use-on-click-outside.hook-fa9c21ca.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
var component$4 = require('./component-39a54733.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
var searchInputV2Constants = require('./search-input-v2-constants-f31caee4.js');
var dropdownItem = require('./dropdown-item-c31b218f.js');

var DropdownContentSwitcher = function (_a) {
    var _b;
    var children = _a.children, value = _a.value;
    if (!value)
        return null;
    return (_b = children.find(function (child) { return child.props['data-value'] === value; })) !== null && _b !== void 0 ? _b : null;
};

var DropdownSpinner = function () { return (React__default.createElement(searchInputV2Constants.DropdownSpinnerContainer, null,
    React__default.createElement(component$4.Spinner, { size: "32px", color: hqoTheme.colors.floorPlan.blue }))); };

var DropdownNoContent = function (_a) {
    var emptyContentLabels = _a.emptyContentLabels;
    return (React__default.createElement(searchInputV2Constants.DropdownNoContentContainer, null,
        React__default.createElement(searchInputV2Constants.NoContentTitle, null, emptyContentLabels.title),
        React__default.createElement(searchInputV2Constants.NoContentSubTitle, null, emptyContentLabels.subtitle)));
};

var DropdownContent = function (_a) {
    var options = _a.options, value = _a.value, onSelect = _a.onSelect, defaultValueIndex = _a.defaultValueIndex;
    return (React__default.createElement(React__default.Fragment, null, options === null || options === void 0 ? void 0 : options.map(function (option, optionPosition) {
        var _a;
        var isActiveOption = value ? option.label === value : option.label === ((_a = options[defaultValueIndex]) === null || _a === void 0 ? void 0 : _a.label);
        var isLastItem = options.length - 1 === optionPosition;
        return (React__default.createElement(dropdownItem.DropdownItem, { active: isActiveOption, item: option, key: option.value || option.label, lastItem: isLastItem, onSelect: onSelect }));
    })));
};

var Dropdown = function (_a) {
    var dropdownMode = _a.dropdownMode, options = _a.options, value = _a.value, onSelect = _a.onSelect, defaultValueIndex = _a.defaultValueIndex, emptyContentLabels = _a.emptyContentLabels;
    return (React__default.createElement(DropdownContentSwitcher, { value: dropdownMode, "data-testid": "dropdown-content-switcher" },
        React__default.createElement(DropdownSpinner, { "data-value": searchInputV2Constants.SearchInputDropdownMode.Spinner }),
        React__default.createElement(DropdownNoContent, { "data-value": searchInputV2Constants.SearchInputDropdownMode.EmptyContent, emptyContentLabels: emptyContentLabels }),
        React__default.createElement(DropdownContent, { "data-value": searchInputV2Constants.SearchInputDropdownMode.Content, options: options, value: value, onSelect: onSelect, defaultValueIndex: defaultValueIndex })));
};

var DropdownPortal = function (_a) {
    var dropdownMode = _a.dropdownMode, options = _a.options, value = _a.value, onSelect = _a.onSelect, defaultValueIndex = _a.defaultValueIndex, emptyContentLabels = _a.emptyContentLabels;
    var dropProps = {
        'data-testid': 'hqo-dropdown-options',
        'data-cy': 'hqo-dropdown-options',
    };
    return (React__default.createElement(searchInputV2Constants.StyledPortalPaper, tslib_es6.__assign({}, dropProps),
        React__default.createElement(Dropdown, { dropdownMode: dropdownMode, options: options, value: value, onSelect: onSelect, defaultValueIndex: defaultValueIndex, emptyContentLabels: emptyContentLabels })));
};

var SearchInputV2 = function (_a) {
    var placeholder = _a.placeholder, _b = _a.id, id = _b === void 0 ? 'input-search-v2-id' : _b, value = _a.value, onChange = _a.onChange, onClearButtonClick = _a.onClearButtonClick, dropdownMode = _a.dropdownMode, options = _a.options, dropdownValue = _a.dropdownValue, onSelectOption = _a.onSelectOption, defaultDropdownValueIndex = _a.defaultDropdownValueIndex, isDropdownVisible = _a.isDropdownVisible, clickOutsideDropdown = _a.clickOutsideDropdown, emptyContentLabels = _a.emptyContentLabels, restProps = tslib_es6.__rest(_a, ["placeholder", "id", "value", "onChange", "onClearButtonClick", "dropdownMode", "options", "dropdownValue", "onSelectOption", "defaultDropdownValueIndex", "isDropdownVisible", "clickOutsideDropdown", "emptyContentLabels"]);
    var ref = React.useRef(null);
    useOnClickOutside_hook.useOnClickOutside(function () { return clickOutsideDropdown(); }, [ref]);
    return (React__default.createElement(searchInputV2Constants.Container, { ref: ref },
        React__default.createElement(formField.FormField, tslib_es6.__assign({ fieldType: formField.FormFieldType.SEARCH_INPUT, id: id, placeholder: placeholder, onClearButtonClick: onClearButtonClick, onChange: onChange }, restProps, { value: value, className: "search-input" })),
        isDropdownVisible && (React__default.createElement(DropdownPortal, { dropdownMode: dropdownMode, options: options, value: dropdownValue, onSelect: onSelectOption, defaultValueIndex: defaultDropdownValueIndex, emptyContentLabels: emptyContentLabels }))));
};

exports.SearchInputV2 = SearchInputV2;
